// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateReturnOrderMutation($input: UpdateReturnOrderInput!) {
    updateReturnOrder(input: $input) {
      returnOrderEdge {
        node {
          id
          returnNumber
          status
          returnType
          reason
          authorizedDate
          receivedDate
          notes
          customerNotes
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, options);
  },
};
